import { Component } from '@angular/core';
import { BaseTableComponent } from '../../../../shared/tables/base-table/base-table';
import {
  DateUtil,
  IncidentListResponseDto, IncidentResponseDto, IncidentUpdateDto
} from '@whetstoneeducation/hero-common';
import { logger } from '../../../../shared/logger';
import { AppIncidentService } from '../../incident.service';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';
import { AppConfirmationDialogService } from 'src/app/shared/confirmation-dialog/confirmation-dialog.service';
import { DEFAULT_DIALOG_RESULT } from 'src/app/shared/confirmation-dialog/confirmation-dialog-options.interface';


enum IncidentTableColumnsEnum {
  INCIDENT_NUMBER = 'Incident Number',
  DATE = 'Date',
  TYPE = 'Type',
  REPORTER = 'Reporter',
  DESCRIPTION = 'Description',
  STATUS = 'Status',
  ACTION = 'Action'
}

@Component({
  selector: 'app-incidents-table',
  templateUrl: './incidents-table.component.html',
  styleUrls: ['./incidents-table.component.scss']
})
export class IncidentsTableComponent extends BaseTableComponent<IncidentListResponseDto> {
  public columns = IncidentTableColumnsEnum;
  public get displayedColumns() {
    return Object.values(IncidentTableColumnsEnum);
  }
  public columnValues = {
      [IncidentTableColumnsEnum.INCIDENT_NUMBER]: ['incidentNumber'],
      [IncidentTableColumnsEnum.DATE]: ['date'],
      [IncidentTableColumnsEnum.TYPE]: ['incidentType'],
      [IncidentTableColumnsEnum.REPORTER]: ['reporter'],
      [IncidentTableColumnsEnum.DESCRIPTION]: ['description'],
      [IncidentTableColumnsEnum.STATUS]: ['status'],
    };
  constructor(
    public incidentService: AppIncidentService,
    public toastManager: AppToastManagerService,
    public confirmationDialog: AppConfirmationDialogService,
  ) {
    super();
  }

  protected readonly DateUtil = DateUtil;

  ngOnInit() {
    this.dataSource.filterPredicate = (data: IncidentListResponseDto) => {
      return !data.deletedAt;
    };
    this.dataSource.filter = 'ACTIVE_ONLY';
  }

  public async toggleActive(incident: IncidentResponseDto) {
    this.isLoading = true;
    try {
      const updateIncident: IncidentUpdateDto =
        new IncidentUpdateDto();
      updateIncident.mapFields(incident);
      updateIncident.date = new Date(incident.date);
      updateIncident.deletedAt = !updateIncident.deletedAt? new Date() : null;
      updateIncident.participants = [];
      await this.incidentService.updateIncident(incident.id, updateIncident);
      this.dataArr = this.dataArr.filter((data) => data.id !== incident.id);
      this.toastManager.success(
        `Incident "${incident.incidentNumber}" ${
          incident.deletedAt ? 'reactivated' : 'deleted'
        } successfully!`
      );
    } catch (err) {
      logger.error(err);
      this.toastManager.error(
        'There was an error deleting this incident, please try again!'
      );
    }
    this.isLoading = false;
  }

    public async displayDeleteConfirmationModal(
      incidentRow: IncidentResponseDto
    ): Promise<void> {
      const ref = this.confirmationDialog.openDialog({
        title: `Delete Incident`,
        content: 'Are you sure you want to delete this incident?'
      });
      ref.afterClosed().subscribe(async (result: string) => {
        if (result === DEFAULT_DIALOG_RESULT.YES) {
          await this.toggleActive(incidentRow);
        }
      });
    }
}
